import { UserBonusCheckpointStatus } from '@/enums/userBonusCheckpointStatus';
import { useEffect, useRef, useState } from 'react';

export function useAnimateOnStatusChange(
  status: UserBonusCheckpointStatus | undefined,
) {
  const [animate, setAnimate] = useState<boolean>(false);
  const previousStatusRef = useRef(status);

  function onStatusChange() {
    if (typeof window == 'undefined' && !previousStatusRef?.current) {
      return;
    }
    const previousStatus = previousStatusRef.current;

    if (
      previousStatus === UserBonusCheckpointStatus.Fulfilled &&
      status === UserBonusCheckpointStatus.Claimed
    ) {
      setAnimate(true);
      return;
    }

    setAnimate(false);
    previousStatusRef.current = status;
  }

  useEffect(onStatusChange, [status]);

  return { animate };
}
